import { defineMessages, FormattedMessage } from 'react-intl';

import { confirmationToast, failureToast } from '../components/Toast';

export const clipboardMessages = defineMessages({
  copiedSuccess: { defaultMessage: 'Copied to clipboard', id: '93oVTh' },
  copiedFailure: { defaultMessage: 'An error occurred while copying', id: 'vxNncs' },
  noTextToCopy: { defaultMessage: 'No text to copy', id: 'DI1Hxj' },
});

export const copyToClipboard = (text: string | undefined) =>
  text
    ? navigator.clipboard
        .writeText(text)
        .then(() =>
          confirmationToast(<FormattedMessage {...clipboardMessages.copiedSuccess} />, {
            toastId: 'copySuccess',
          }),
        )
        .catch(() =>
          failureToast(<FormattedMessage {...clipboardMessages.copiedFailure} />, {
            toastId: 'copyFailure',
          }),
        )
    : failureToast(<FormattedMessage {...clipboardMessages.noTextToCopy} />, { toastId: 'noText' });
